/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupProps } from "@insite/mobius/CheckboxGroup";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import ArrowRightLongIcon from "@tCentro/Icons/ArrowRightLongIcon";
import CenArrowRightIcon from "@tCentro/Icons/CenArrowRightIcon";
import { COLORS } from "@tCentro/theme/design";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}

export interface RecentOrderListHeadingStyles {
    headingStyles?: InjectableCss;
    checkboxStyles?: CheckboxPresentationProps;
    checkboxContainer?: CheckboxGroupProps;
    allOrderLinkStyles?: LinkPresentationProps;
    leftContentStyles?: InjectableCss;
    headingMainContainer?: InjectableCss;
}

export const recentOrderListHeadingStyles: RecentOrderListHeadingStyles = {
    headingMainContainer: {
        css: css`
            justify-content: space-between;
            width: 100%;
            display: flex;
            align-items: center;
            /* border: 4px solid #f2f2f2; */
            border-bottom: none !important;
            padding: 38px 20px 0px 20px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        gap: 24px;
                        align-items: flex-start;
                    `,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    leftContentStyles: {
        css: css`
            display: flex;
            gap: 24px;
            justify-content: flex-start;
            align-items: center;
        `,
    },
    headingStyles: {
        css: css`
            font-family: Poppins;
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
            text-align: left;
            color: ${getProp("theme.typography.p.color")};
            text-transform: uppercase;
        `,
    },
    checkboxStyles: {
        typographyProps: {
            css: css``,
        },
        iconProps: {
            size: 18,
            css: css`
                + label {
                    color: black !important;
                    font-family: Poppins;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 16px;
                }
            `,
        },
    },

    allOrderLinkStyles: {
        css: css`
            margin-left: auto;
            margin-top: 5px;
            flex-direction: row-reverse;
            gap: 4px;
            border-radius: 16px;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;
            span {
                font-size: 14px;
            }
        `,
    },
};

const styles = recentOrderListHeadingStyles;
const CENRecentOrdersCardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return (
        <StyledWrapper {...styles.headingMainContainer}>
            <StyledWrapper>
                <Typography className="card-list-heading" {...styles.headingStyles}>
                    {heading}
                </Typography>
            </StyledWrapper>

            {viewAllUrl && (
                <StyledWrapper>
                    <Link
                        {...styles.allOrderLinkStyles}
                        href={viewAllUrl}
                        icon={{
                            iconProps: {
                                src: ArrowRightLongIcon,
                                size: 16,
                                css: css`
                                    svg {
                                        > path {
                                            fill: ${getColor("text.link")} !important;
                                        }
                                    }
                                `,
                            },
                        }}
                        typographyProps={{ size: 15 }}
                        className="view-all-link"
                        data-test-selector="cardListHeadingViewAllLink"
                    >
                        {translate("All Quotes")}
                        <VisuallyHidden>
                            {translate("All Quotes")} {heading}
                        </VisuallyHidden>
                    </Link>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

export default CENRecentOrdersCardListHeading;
